<script setup>
	import { computed } from 'vue';
	import { formConfig } from '@/js/formConfig.js';
	import { useStore } from 'vuex';
	const store = useStore();

	// eslint-disable-next-line no-unused-vars
	import IconsSvg from '@/components/IconsSvg';

	// eslint-disable-next-line no-unused-vars
	const isStepPassed = computed(() => {
		// Determine current step
		// Determine crumb step and if it's index is inferior
		return false;
	});

	// What is the current step?
	// eslint-disable-next-line no-unused-vars
	const currentStepIndex = computed(() => {
		const currentPage = store.getters.getCurrentPage;
		const idx = formConfig.listOfBreadcrumbStepsForThisAction.findIndex(step => step.activeOnPages.includes(currentPage))
		return idx === -1 ? 0 : idx; // fallback to 0 if page not found in the config
	});
</script>

<!-- ================================================================================== -->

<template>
	<div v-if="formConfig.isBreadcrumbDisplayed">
		<div class="breadcrumbs" aria-label="Fil d'ariane / breadcrumb" tabindex="0">

			<h3 v-if="formConfig.isBreadCrumbTitleVisible">
				<span v-if="store.getters.getCurrentPage !== 'confirmation'">{{ $t('breadcrumbSteps.title') }}</span>
				<span v-if="store.getters.getCurrentPage === 'confirmation'">{{ $t('breadcrumbSteps.titleConfirmPage') }}</span>
			</h3>

			<div class="stepswrapper">

				<div 
				v-for="(steps, index) in formConfig.listOfBreadcrumbStepsForThisAction" 
				:key="index" 
				class="step" 
				:class="{
					'past': currentStepIndex >= 0 && index < currentStepIndex, 
					'current': index === currentStepIndex
				}">

				<icons-svg :icon="steps.icon" class="iconbox" />

				<div class="number">
					<span>
						{{index + 1}}
					</span>
				</div>

				<div class="label" :id="`labelfor-${steps.translation}`">
					<span>
						{{ $t(`breadcrumbSteps.${steps.translation}`) }}
					</span>
				</div>

			</div>
		</div>

	</div>
</div>
</template>

<!-- ================================================================================== -->

<style scoped>
</style>
